import { HTMLAttributes } from "react";
import cx from "classnames";

export type ContainerProps = HTMLAttributes<HTMLDivElement>;

export default function Card({ children, className, ...rest }: ContainerProps) {
    return (
        <div
            className={cx("container mx-auto px-4 sm:px-6 lg:px-8", className)}
            {...rest}>
            {children}
        </div>
    );
}
